import { axiosCompanyPortalInstance } from "./";

const LOGISTICS_ISSUES_PATH = "/logistics_issues";

/** GET /company_portal/v1/logistics_issues */
const getCompanyLogisticsIssues = (params = {}, config = {}) =>
  axiosCompanyPortalInstance.get(LOGISTICS_ISSUES_PATH, { ...config, params });

/** GET /company_portal/v1/logistics_issues/:id */
const getCompanyLogisticsIssue = (id) =>
  axiosCompanyPortalInstance.get(`${LOGISTICS_ISSUES_PATH}/${id}`);

/** POST /company_portal/v1/logistics_issues */
const createCompanyLogisticsIssue = (data) =>
  axiosCompanyPortalInstance.post(LOGISTICS_ISSUES_PATH, data);

/** PATCH /company_portal/v1/logistics_issues/:id */
const updateCompanyLogisticsIssue = ({ id, data }) =>
  axiosCompanyPortalInstance.patch(`${LOGISTICS_ISSUES_PATH}/${id}`, data);

/** GET /company_portal/v1/logistics_issues/:id/logistics_issue_comments */
const getCompanyLogisticsIssueComments = (id, params = {}) =>
  axiosCompanyPortalInstance.get(
    `${LOGISTICS_ISSUES_PATH}/${id}/logistics_issue_comments`,
    { params },
  );

/** POST /company_portal/v1/logistics_issues/:id/logistics_issue_comments */
const createCompanyLogisticsIssueComment = ({ id, data }) =>
  axiosCompanyPortalInstance.post(
    `${LOGISTICS_ISSUES_PATH}/${id}/logistics_issue_comments`,
    data,
  );

/** GET /company_portal/v1/logistics_issues/export_to_xls */
const exportCompanyLogisticsIssues = (params = {}) =>
  axiosCompanyPortalInstance.get(`${LOGISTICS_ISSUES_PATH}/export_to_xls`, {
    params,
    responseType: "blob",
  });

export {
  getCompanyLogisticsIssues,
  getCompanyLogisticsIssue,
  createCompanyLogisticsIssue,
  updateCompanyLogisticsIssue,
  getCompanyLogisticsIssueComments,
  createCompanyLogisticsIssueComment,
  exportCompanyLogisticsIssues,
};
